type IconProps = React.SVGProps<SVGSVGElement>;

const TransactionSuccess: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.9375 21.125L23.0208 32.5L17.0625 26.8125M11.0624 40.9376C9.19281 39.0681 10.4328 35.143 9.48122 32.8431C8.49476 30.4589 4.875 28.5401 4.875 25.9999C4.875 23.4598 8.49478 21.541 9.48123 19.1569C10.4328 16.857 9.19281 12.9319 11.0624 11.0624C12.9319 9.19281 16.857 10.4328 19.1569 9.48122C21.5411 8.49476 23.4599 4.875 26.0001 4.875C28.5402 4.875 30.459 8.49478 32.8431 9.48123C35.143 10.4328 39.0681 9.19281 40.9376 11.0624C42.8072 12.9319 41.5672 16.857 42.5188 19.1569C43.5052 21.5411 47.125 23.4599 47.125 26.0001C47.125 28.5402 43.5052 30.459 42.5188 32.8431C41.5672 35.143 42.8072 39.0681 40.9376 40.9376C39.0681 42.8072 35.143 41.5672 32.8431 42.5188C30.4589 43.5052 28.5401 47.125 25.9999 47.125C23.4598 47.125 21.541 43.5052 19.1569 42.5188C16.857 41.5672 12.9319 42.8072 11.0624 40.9376Z"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TransactionSuccess;
